import { NgModule } from "@angular/core";

import { MatDateFormats, MatNativeDateModule, MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  NgxMatDateFormats,
  NgxMatDatetimePickerModule,
  NGX_MAT_DATE_FORMATS,
} from "@angular-material-components/datetime-picker";
import {
  NgxMatMomentModule,
  NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular-material-components/moment-adapter";
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateModule,
} from "@angular/material-moment-adapter";

const DEFAULT_DATETIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

const CUSTOM_DATETIME_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: DEFAULT_DATETIME_FORMAT,
  },
  display: {
    dateInput: DEFAULT_DATETIME_FORMAT,
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: DEFAULT_DATE_FORMAT,
  },
  display: {
    dateInput: DEFAULT_DATE_FORMAT,
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@NgModule({
  imports: [
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatMomentModule,
    NgxMatDatetimePickerModule,
    MatMomentDateModule,
    MomentDateModule,
  ],
  exports: [
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatMomentModule,
    NgxMatDatetimePickerModule,
    MatMomentDateModule,
    MomentDateModule,
  ],
  providers: [
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATETIME_FORMATS },
    {
      provide: NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: false },
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
  ],
})
export class DateTimeModule {}
